// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"5504fd1e52d4502d77e5","522":"e9fb79faa67234c9ad5b"}[chunkId] + ".js";
};